module.exports = __webpack_public_path__ + "img/scancode.82019ff0.png";